import React from "react";
import Content from "../components/Common/Content";
import Layout from "../components/Common/Layout";
import Main from "../components/Common/Main";
import Paragraph from "../components/Common/Paragrpah";
import Section from "../components/Common/Section";
import Subtitle from "../components/Common/Subtitle";
import Title from "../components/Common/Title";
import Spacing from "../constants/Spacing";
import SEO from "../components/Common/SEO";

const FAQ = () => {
    return (
        <Layout title="LearnCMD FAQ - Common Questions About Our Terminal Learning Platform">
            <SEO 
                title="LearnCMD FAQ - Common Questions About Our Terminal Learning Platform"
                description="Find answers to frequently asked questions about LearnCMD's terminal learning platform. Learn about our course structure, pricing, refund policy, and technical requirements."
                pathname="/faq"
            />
            <Main>
                <Section marginBottom={Spacing.SPACING_7}>
                    <Content>
                        <Title
                            marginTop={Spacing.SPACING_3}
                            marginBottom={Spacing.SPACING_3}
                        >
                            Frequently Asked Questions
                        </Title>
                        <Subtitle marginBottom={Spacing.SPACING_2}>
                            For how long can I use the package after the purchase?
                        </Subtitle>
                        <Paragraph marginBottom={Spacing.SPACING_3}>
                            After purchasing, you'll have full access to everything for 365 days. That’s plenty of time to sharpen your command-line skills!
                        </Paragraph>
                        <Subtitle marginBottom={Spacing.SPACING_2}>
                            What if I don't like it?
                        </Subtitle>
                        <Paragraph marginBottom={Spacing.SPACING_3}>
                            If you’re not satisfied for any reason, just email us within the first 7 days and we’ll give you a full refund—no questions asked.
                            <br />
                            <br />
                            We may ask for feedback to improve the program, but you’re not obligated to respond. The refund is unconditional.
                        </Paragraph>
                        <Subtitle marginBottom={Spacing.SPACING_2}>
                            What if I get stuck? Can I ask questions?
                        </Subtitle>
                        <Paragraph marginBottom={Spacing.SPACING_3}>
                            Absolutely!
                            <br />
                            <br />
                            We use Discord as our community platform. 
                        </Paragraph>
                        <Subtitle marginBottom={Spacing.SPACING_2}>
                            Do you offer a certificate of completion?
                        </Subtitle>
                        <Paragraph marginBottom={Spacing.SPACING_3}>
                            Yes! Once you complete all the modules, you can download a personalized PDF certificate proving you’ve completed the LearnCMD program.
                            <br />
                            <br />
                            This can help with employer reimbursements, sharing your achievement online, or simply celebrating your progress.
                        </Paragraph>
                        <Subtitle marginBottom={Spacing.SPACING_2}>
                            What do I need for this program?
                        </Subtitle>
                        <Paragraph marginBottom={Spacing.SPACING_3}>
                            All you need is a browser and some free time. No software installation is required, and no prior Linux or command-line experience is necessary.
                        </Paragraph>
                        <Subtitle marginBottom={Spacing.SPACING_2}>
                            What is included?
                        </Subtitle>
                        <Paragraph marginBottom={Spacing.SPACING_3}>
                            The program includes 10 modules—over 50 lessons in total. You’ll also get access to cheat sheets, diagrams, command walkthroughs, and other extra materials.
                        </Paragraph>
                        <Subtitle marginBottom={Spacing.SPACING_2}>
                            What about a receipt, so I can be reimbursed?
                        </Subtitle>
                        <Paragraph marginBottom={Spacing.SPACING_3}>
                            You’ll receive a receipt/invoice by email immediately after purchase. You can add your name, address, and VAT number to meet any reimbursement requirements.
                        </Paragraph>
                        <Subtitle marginBottom={Spacing.SPACING_2}>
                            Which Linux distribution and shell is this based on?
                        </Subtitle>
                        <Paragraph marginBottom={Spacing.SPACING_3}>
                            The learning environment uses Ubuntu Linux and the Bash shell. Most content is also relevant for other Linux distributions and popular shells. It’s also highly applicable for Mac users.
                        </Paragraph>
                        <Subtitle marginBottom={Spacing.SPACING_2}>
                            Can I learn at my own pace?
                        </Subtitle>
                        <Paragraph marginBottom={Spacing.SPACING_3}>
                            Yes! The entire program is self-paced. You can go through the lessons whenever it suits you—no deadlines, no pressure.
                        </Paragraph>
                        <Subtitle marginBottom={Spacing.SPACING_2}>
                            Can I access the course on my phone or tablet?
                        </Subtitle>
                        <Paragraph marginBottom={Spacing.SPACING_3}>
                            Absolutely. LearnCMD works on all modern browsers, including those on mobile devices. For the best experience, we recommend a desktop or laptop, especially for interactive terminal lessons.
                        </Paragraph>
                        <Subtitle marginBottom={Spacing.SPACING_2}>
                            Is this suitable for beginners?
                        </Subtitle>
                        <Paragraph marginBottom={Spacing.SPACING_3}>
                            Definitely. The course is designed for complete beginners and gradually builds up to more advanced topics. No prior command-line knowledge is needed.
                        </Paragraph>
                        <Subtitle marginBottom={Spacing.SPACING_2}>
                            Can I preview a lesson before buying?
                        </Subtitle>
                        <Paragraph marginBottom={Spacing.SPACING_3}>
                            Yes! Two full modules are available for free, so you can try LearnCMD without any commitment. You’ll get access to real lessons and exercises to see if the course is right for you.
                        </Paragraph>
                        <Subtitle marginBottom={Spacing.SPACING_2}>
                            I have a question not listed here!
                        </Subtitle>
                        <Paragraph marginBottom={Spacing.SPACING_3}>
                            We can be reached at{" "}
                            <strong>team@learncmd.io</strong> Feel free to ask
                            anything.
                        </Paragraph>
                    </Content>
                </Section>
            </Main>
        </Layout>
    );
};

export default FAQ;
